var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"NewBlockButton",on:{"click":() => _vm.onClick(_vm.type)}},[_c('i',{staticClass:"NewBlockButton-Icon",class:[_vm.icon]}),_c('span',{staticClass:"NewBlockButton-Name"},[_vm._v(_vm._s(_vm.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }